import { httpClientWithoutInterceptors } from '@/utils/httpClient'
import { useQuery } from '@tanstack/vue-query'
import { usePaginatedTanstackQueryParams } from '@/composables/helpers'
import { PaginatedTanstackQueryParams } from '@/lib/types/v1'
import { QueryKeys } from '@/modules/radius/queries/v1/query-keys'
import { paginatedRadiusServersSchema } from '@/modules/radius/schema/v1/server'
import { AxiosResponse } from 'axios'
import { clean_query_keys } from '@/lib/utils'

export const usePaginatedRadiusServersQuery = (
    params?: PaginatedTanstackQueryParams | (() => PaginatedTanstackQueryParams)
) => {
    const { queryKey, key, page, limit, sort, filter, q, view, groupBy, enabled, staleTime } =
        usePaginatedTanstackQueryParams(params)

    return useQuery({
        queryKey: clean_query_keys([QueryKeys.Servers, QueryKeys.PaginatedServers, queryKey, key]),
        queryFn: () => {
            return httpClientWithoutInterceptors.get('v1/radius/servers', {
                params: {
                    page: page.value,
                    limit: limit.value,
                    sort: sort.value,
                    filter: filter.value,
                    q: q.value,
                    view: view.value,
                    group_by: groupBy.value,
                },
            })
        },
        select(data: AxiosResponse) {
            return paginatedRadiusServersSchema.parse(data.data)
        },
        enabled: enabled,
        staleTime: staleTime,
    })
}
